import React from 'react';
import DashboardLayout from '../DashboardLayout';

const ProformaLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default ProformaLayout;
